__turbopack_context__.v({
  "accordionBody": "ServiceVerticalLandingPage-module__dZNXDG__accordionBody",
  "accordionButton": "ServiceVerticalLandingPage-module__dZNXDG__accordionButton",
  "accordionChevron": "ServiceVerticalLandingPage-module__dZNXDG__accordionChevron",
  "accordionGrid": "ServiceVerticalLandingPage-module__dZNXDG__accordionGrid",
  "accordionHeader": "ServiceVerticalLandingPage-module__dZNXDG__accordionHeader",
  "accordionIcon": "ServiceVerticalLandingPage-module__dZNXDG__accordionIcon",
  "accordionItem": "ServiceVerticalLandingPage-module__dZNXDG__accordionItem",
  "accordionLabel": "ServiceVerticalLandingPage-module__dZNXDG__accordionLabel",
  "accordionLeft": "ServiceVerticalLandingPage-module__dZNXDG__accordionLeft",
  "accordionRight": "ServiceVerticalLandingPage-module__dZNXDG__accordionRight",
  "body": "ServiceVerticalLandingPage-module__dZNXDG__body",
  "brandLogoCard": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoCard",
  "brandLogoCopy": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoCopy",
  "brandLogoGrid": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoGrid",
  "brandLogoGrids": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoGrids",
  "brandLogoImage": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoImage",
  "brandLogoRow": "ServiceVerticalLandingPage-module__dZNXDG__brandLogoRow",
  "bubbleHeadline": "ServiceVerticalLandingPage-module__dZNXDG__bubbleHeadline",
  "bullet": "ServiceVerticalLandingPage-module__dZNXDG__bullet",
  "bullets": "ServiceVerticalLandingPage-module__dZNXDG__bullets",
  "caseStudyCard": "ServiceVerticalLandingPage-module__dZNXDG__caseStudyCard",
  "caseStudyGrid": "ServiceVerticalLandingPage-module__dZNXDG__caseStudyGrid",
  "caseStudyIcon": "ServiceVerticalLandingPage-module__dZNXDG__caseStudyIcon",
  "caseStudyTitle": "ServiceVerticalLandingPage-module__dZNXDG__caseStudyTitle",
  "checklist": "ServiceVerticalLandingPage-module__dZNXDG__checklist",
  "checklistCheck": "ServiceVerticalLandingPage-module__dZNXDG__checklistCheck",
  "checklistColumn": "ServiceVerticalLandingPage-module__dZNXDG__checklistColumn",
  "checklistColumns": "ServiceVerticalLandingPage-module__dZNXDG__checklistColumns",
  "checklistItem": "ServiceVerticalLandingPage-module__dZNXDG__checklistItem",
  "checklistLabel": "ServiceVerticalLandingPage-module__dZNXDG__checklistLabel",
  "columnCta": "ServiceVerticalLandingPage-module__dZNXDG__columnCta",
  "galleryCard": "ServiceVerticalLandingPage-module__dZNXDG__galleryCard",
  "galleryContent": "ServiceVerticalLandingPage-module__dZNXDG__galleryContent",
  "galleryGrid": "ServiceVerticalLandingPage-module__dZNXDG__galleryGrid",
  "galleryImage": "ServiceVerticalLandingPage-module__dZNXDG__galleryImage",
  "galleryImageWrap": "ServiceVerticalLandingPage-module__dZNXDG__galleryImageWrap",
  "galleryPrice": "ServiceVerticalLandingPage-module__dZNXDG__galleryPrice",
  "galleryTagline": "ServiceVerticalLandingPage-module__dZNXDG__galleryTagline",
  "galleryTitle": "ServiceVerticalLandingPage-module__dZNXDG__galleryTitle",
  "h2": "ServiceVerticalLandingPage-module__dZNXDG__h2",
  "h3": "ServiceVerticalLandingPage-module__dZNXDG__h3",
  "h4": "ServiceVerticalLandingPage-module__dZNXDG__h4",
  "heroCopy": "ServiceVerticalLandingPage-module__dZNXDG__heroCopy",
  "heroCta": "ServiceVerticalLandingPage-module__dZNXDG__heroCta",
  "heroEyebrow": "ServiceVerticalLandingPage-module__dZNXDG__heroEyebrow",
  "heroIntro": "ServiceVerticalLandingPage-module__dZNXDG__heroIntro",
  "heroSimple": "ServiceVerticalLandingPage-module__dZNXDG__heroSimple",
  "heroSimpleInner": "ServiceVerticalLandingPage-module__dZNXDG__heroSimpleInner",
  "heroSplit": "ServiceVerticalLandingPage-module__dZNXDG__heroSplit",
  "heroSplitGrid": "ServiceVerticalLandingPage-module__dZNXDG__heroSplitGrid",
  "heroSplitImage": "ServiceVerticalLandingPage-module__dZNXDG__heroSplitImage",
  "heroSplitImageWrap": "ServiceVerticalLandingPage-module__dZNXDG__heroSplitImageWrap",
  "heroSplitSecondaryImage": "ServiceVerticalLandingPage-module__dZNXDG__heroSplitSecondaryImage",
  "heroTitle": "ServiceVerticalLandingPage-module__dZNXDG__heroTitle",
  "hubspotFormEmbed": "ServiceVerticalLandingPage-module__dZNXDG__hubspotFormEmbed",
  "image": "ServiceVerticalLandingPage-module__dZNXDG__image",
  "imageAnchor": "ServiceVerticalLandingPage-module__dZNXDG__imageAnchor",
  "imageParagraph": "ServiceVerticalLandingPage-module__dZNXDG__imageParagraph",
  "imageWrap": "ServiceVerticalLandingPage-module__dZNXDG__imageWrap",
  "link": "ServiceVerticalLandingPage-module__dZNXDG__link",
  "page": "ServiceVerticalLandingPage-module__dZNXDG__page",
  "paragraph": "ServiceVerticalLandingPage-module__dZNXDG__paragraph",
  "secOpsGrid": "ServiceVerticalLandingPage-module__dZNXDG__secOpsGrid",
  "secOpsImage": "ServiceVerticalLandingPage-module__dZNXDG__secOpsImage",
  "secOpsImageWrap": "ServiceVerticalLandingPage-module__dZNXDG__secOpsImageWrap",
  "secOpsMain": "ServiceVerticalLandingPage-module__dZNXDG__secOpsMain",
  "section": "ServiceVerticalLandingPage-module__dZNXDG__section",
  "sectionEyebrow": "ServiceVerticalLandingPage-module__dZNXDG__sectionEyebrow",
  "sectionTitleRow": "ServiceVerticalLandingPage-module__dZNXDG__sectionTitleRow",
  "serviceCard": "ServiceVerticalLandingPage-module__dZNXDG__serviceCard",
  "serviceGrid": "ServiceVerticalLandingPage-module__dZNXDG__serviceGrid",
  "splitHeadingColumn": "ServiceVerticalLandingPage-module__dZNXDG__splitHeadingColumn",
  "splitHeadingGrid": "ServiceVerticalLandingPage-module__dZNXDG__splitHeadingGrid",
  "splitHeadingItem": "ServiceVerticalLandingPage-module__dZNXDG__splitHeadingItem",
  "standaloneImage": "ServiceVerticalLandingPage-module__dZNXDG__standaloneImage",
  "successStoriesAnchor": "ServiceVerticalLandingPage-module__dZNXDG__successStoriesAnchor",
  "successStoriesGrid": "ServiceVerticalLandingPage-module__dZNXDG__successStoriesGrid",
  "successStory": "ServiceVerticalLandingPage-module__dZNXDG__successStory",
  "successStoryDescription": "ServiceVerticalLandingPage-module__dZNXDG__successStoryDescription",
  "successStoryName": "ServiceVerticalLandingPage-module__dZNXDG__successStoryName",
});
